import { useContext } from 'react';
import { CurrentEntityContext } from '@identity/contexts';
import { ErrorHandler } from '@common/components';
import { CurrentEntityType } from '@institutions/graphql';

export const useCurrentEntity = () => {
  const entity = useContext<CurrentEntityType | null>(CurrentEntityContext);

  if (!entity) {
    ErrorHandler.showErrorNotification();
    return {} as CurrentEntityType;
  }

  return entity;
};
